export default "__VITE_ASSET__kYFBYu5U__"